import { render, staticRenderFns } from "./modalDetailApproval.vue?vue&type=template&id=3340633e&scoped=true"
import script from "./modalDetailApproval.vue?vue&type=script&lang=js"
export * from "./modalDetailApproval.vue?vue&type=script&lang=js"
import style0 from "./modalDetailApproval.vue?vue&type=style&index=0&id=3340633e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3340633e",
  null
  
)

export default component.exports